import { Link } from "react-router-dom";
import { Icon } from "@/components/Icon";
import { PageHero } from "@/components/PublicLayout";
import { Reveal } from "@/components/Reveal";
import { CTABanner } from "@/components/CTABanner";
import { useSite, mediaUrl } from "@/context/SiteContext";
import { SERVICES, IMAGES } from "@/lib/data";

export default function Services() {
  const content = useSite();
  const pic = (id, fb) => (id ? mediaUrl(id) : fb);
  const imgFor = {
    "nemt": pic(content.nemt_image_id, IMAGES.nemt),
    "wheelchair-transportation": pic(content.wheelchair_image_id, IMAGES.wheelchair),
    "ambulatory-transportation": pic(content.ambulatory_image_id, IMAGES.ambulatory),
    "odp-transportation": pic(content.odp_companion_image_id, IMAGES.odpCommunity),
    "private-pay": pic(content.nemt_image_id, IMAGES.nemt),
    "facility-transportation-solutions": pic(content.facilities_image_id, IMAGES.facilities),
  };

  return (
    <>
      <PageHero
        eyebrow="Our Services"
        title="Transportation Services Built Around You"
        subtitle="From non-emergency medical transportation to community and facility solutions, CareDeserved offers a full range of dependable, compassionate transportation options across Pennsylvania."
      />
      <section className="bg-brand-bg py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-7 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={i * 0.06}>
                <Link to={s.path} data-testid={`services-index-${s.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl">
                  <div className="relative h-48 overflow-hidden">
                    <img src={imgFor[s.slug] || IMAGES.nemt} alt={s.title} loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <span className="absolute -bottom-5 left-6 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-purple text-white shadow-lg">
                      <Icon name={s.icon} size={22} weight="fill" />
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-6 pt-8">
                    <h3 className="font-heading text-lg font-semibold text-slate-900">{s.title}</h3>
                    <p className="mt-2.5 flex-1 text-[15px] leading-relaxed text-slate-600">{s.card}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-purple">
                      {s.cta} <Icon name="ArrowRight" size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABanner />
    </>
  );
}
